import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

import { InputField } from '@/shared/components/atoms';
import { ILinkedInputsProps } from '@/shared/components/molecules/LinkedInputs/LinkedInputs';

import ArrowRightLeft from '~/images/shared/arrows/arrow-right-left.svg';
import ArrowUpDown from '~/images/shared/arrows/Arrow-up-down.svg';

const LinkedInputs: React.FC<ILinkedInputsProps> = ({
  alignment = 'col',
  inputProps,
}) => {
  const { register } = useFormContext();

  return (
    <div
      className={classNames(
        'flex items-center gap-16',
        alignment === 'col' && 'flex-col'
      )}
    >
      <InputField
        {...inputProps[0]}
        {...register(inputProps[0].id as string)}
        label={alignment === 'col' ? inputProps[0].label : undefined}
        onChange={inputProps[0].onChange}
        type='number'
        className='w-full !rounded-xl bg-background-transparent desktop:max-h-56'
        labelClasseName='!text-14'
        borderColor='border-outline-variant'
        textColor='text-text-default'
        width='w-full'
        py='!py-14'
      />
      <span className='text-surface-10'>
        {alignment === 'col' ? (
          <ArrowUpDown width='20' height='20' />
        ) : (
          <ArrowRightLeft width='20' height='20' />
        )}
      </span>
      <InputField
        {...inputProps[1]}
        label={alignment === 'col' ? inputProps[1].label : undefined}
        {...register(inputProps[1].id as string)}
        onChange={inputProps[1].onChange}
        type='number'
        className='w-full !rounded-xl bg-background-transparent desktop:max-h-56'
        labelClasseName='!text-14'
        borderColor='border-outline-variant'
        textColor='text-text-default'
        width='w-full'
        py='!py-14'
      />
    </div>
  );
};

export default LinkedInputs;
